import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '../../../automationStudioIcons';
import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';

export default function CollapsibleSection({
    icon: Icon,
    title,
    badge,
    isExpanded,
    onToggle,
    height,
    onResizeStart,
    children,
    expandAriaLabel,
    collapseAriaLabel,
}) {
    return (
        <div className={styles.leftPanelSection} style={{ flexShrink: 0 }}>
            {isExpanded && onResizeStart && (
                <div
                    className={styles.resizeHandle}
                    onMouseDown={onResizeStart}
                />
            )}
            <div
                className={styles.sectionHeaderCollapsible}
                onClick={onToggle}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <Icon className={styles.sectionIcon} />
                    <span className={`${styles.sectionTitle} ${styles.asTypoSubtitle2}`}>
                        {title}
                    </span>
                    {badge != null && (
                        <div className={styles.sectionBadge}>{badge}</div>
                    )}
                </div>
                <button
                    type="button"
                    className={styles.asIconButton}
                    style={{ padding: '2px' }}
                    aria-expanded={isExpanded}
                    aria-label={isExpanded ? collapseAriaLabel : expandAriaLabel}
                >
                    {isExpanded ? (
                        <ChevronDownIcon style={{ width: '16px', height: '16px' }} />
                    ) : (
                        <ChevronRightIcon style={{ width: '16px', height: '16px' }} />
                    )}
                </button>
            </div>
            <div className={`${styles.asCollapse} ${isExpanded ? styles.asCollapseOpen : ''}`}>
                <div
                    className={styles.sectionContentResizable}
                    style={height != null ? { height: `${height}px` } : undefined}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}
